import * as React from "react";

function SvgPlayDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M15.485 2.25a2.75 2.75 0 012.745 2.582l.005.168v.445a2.749 2.749 0 011.727 2.387l.005.168v.427a2.752 2.752 0 011.776 2.379l.007.194v8a2.755 2.755 0 01-2.592 2.745l-.168.005H5.01a2.755 2.755 0 01-2.755-2.582L2.25 19v-8a2.75 2.75 0 011.781-2.572L4.032 8a2.75 2.75 0 011.734-2.556V5a2.75 2.75 0 012.582-2.745l.168-.005h6.969zm-4.214 11.753v2.244l1.897-1.122-1.897-1.122zm5.946-7.253H6.782a1.25 1.25 0 00-1.244 1.122L5.532 8l-.001.25h12.935l.001-.25a1.25 1.25 0 00-1.122-1.244l-.128-.006zm-1.732-3H8.516a1.25 1.25 0 00-1.244 1.122L7.266 5v.25h9.469V5a1.25 1.25 0 00-1.122-1.244l-.128-.006z"
        />
        <path
          fill="#98DB69"
          d="M18.99 9.75l.129.006A1.255 1.255 0 0120.25 11v8l-.007.128c-.064.63-.6 1.122-1.253 1.122H5.01l-.129-.006A1.255 1.255 0 013.75 19v-8l.006-.128c.065-.63.6-1.122 1.254-1.122h13.98zm-7.428 2.689a1.256 1.256 0 00-1.791 1.137v3.099l.005.12a1.258 1.258 0 001.892.961l2.619-1.55.117-.077a1.256 1.256 0 00-.117-2.084l-2.62-1.55z"
        />
      </g>
    </svg>
  );
}

export default SvgPlayDuo;
